import script from "./HouseRent.vue?vue&type=script&setup=true&lang=ts"
export * from "./HouseRent.vue?vue&type=script&setup=true&lang=ts"

import "./HouseRent.vue?vue&type=style&index=0&id=4dd66083&lang=less&scoped=true"

import exportComponent from "D:\\Code\\BranchManageSystem\\UI\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dd66083"]])

export default __exports__